var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_c('gl-sprintf',{attrs:{"message":_vm.$options.alertMessage},scopedSlots:_vm._u([{key:"link",fn:function(ref){
var content = ref.content;
return [_c('gl-link',{attrs:{"href":_vm.currentPath,"target":"_blank","rel":"nofollow"}},[_vm._v("\n        "+_vm._s(content)+"\n      ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }